export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
}

export const articles: Article[] = [
  {
    slug: '2025-domestic-film-market-analysis',
    title: '2025年国产电影市场深度分析：票房突破800亿背后的产业变革',
    excerpt: '2025年中国电影市场迎来历史性突破，全年总票房突破800亿元人民币。本文从产业格局、内容创新、技术赋能三个维度深入剖析国产电影市场的变革之路。',
    content: `<p>2025年，中国电影市场迎来了里程碑式的突破。据国家电影局最新数据显示，全年总票房首次突破800亿元人民币，同比增长18.6%，国产影片市场份额达到78.3%，创历史新高。</p>
    <h2>一、票房结构优化：多元类型齐头并进</h2>
    <p>与往年相比，2025年国产电影的类型结构更加均衡。科幻片《星际征途2》以68亿元票房领跑年度榜单，现实主义题材《人间世》以45亿元紧随其后，动画电影《山海经·重生》以38亿元位列第三。值得注意的是，中小成本文艺片《归途列车》凭借口碑逆袭，最终收获12亿元票房，创下文艺片票房新纪录。</p>
    <h2>二、技术赋能：虚拟制作与AI技术广泛应用</h2>
    <p>2025年是虚拟制作技术全面落地的一年。超过60%的国产大片采用了LED虚拟拍摄技术，显著降低了后期制作成本和时间。AI技术在剧本评估、特效生成、智能剪辑等环节的应用日益成熟，推动行业效率提升超过30%。</p>
    <h2>三、院线生态升级：沉浸式观影体验成标配</h2>
    <p>全国IMAX、CINITY、杜比影院等高端影厅数量突破5000块，沉浸式观影体验正在成为观众选择影院的重要考量因素。三四线城市影院建设加速，下沉市场票房贡献率首次超过40%。</p>
    <h2>四、出海步伐加快：国产电影国际化进程提速</h2>
    <p>2025年国产电影海外票房突破15亿美元，较上年增长45%。《星际征途2》在全球60个国家和地区同步上映，海外票房超过3亿美元。Netflix、Amazon Prime等国际流媒体平台加大了对国产电影的采购力度。</p>`,
    category: 'films-tv',
    categoryName: '影视剧集',
    author: '张明远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20business%20attire%20with%20warm%20lighting%20and%20clean%20white%20background%2C%20editorial%20headshot%20photography%20style%20with%20soft%20natural%20light&width=80&height=80&seq=avatar-zhang-2025&orientation=squarish',
    publishDate: '2025-12-28',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20theater%20interior%20with%20modern%20design%20and%20warm%20ambient%20lighting%2C%20crowded%20cinema%20hall%20with%20red%20seats%20and%20large%20screen%20showing%20film%2C%20cinematic%20atmosphere%20with%20golden%20accents%2C%20editorial%20photography%20style&width=1600&height=900&seq=film-market-2025&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    tags: ['电影市场', '票房分析', '产业变革', '国产电影'],
    isHot: true,
    isFeatured: true,
  },
  {
    slug: 'ai-media-content-revolution',
    title: 'AI赋能传媒内容生产：效率提升与创作边界的新探索',
    excerpt: '人工智能技术正在深度重塑传媒行业的内容生产链条。从智能写作到虚拟主播，从个性化推荐到自动化剪辑，AI正在为传媒行业打开全新的想象空间。',
    content: `<p>人工智能正在以前所未有的速度渗透到传媒行业的各个环节。2025年，AI在传媒内容生产领域的应用已经从"锦上添花"转变为"核心生产力"，正在重新定义内容创作的边界和效率标准。</p>
    <h2>一、智能写作：从辅助工具到创作伙伴</h2>
    <p>头部传媒机构已经将AI写作工具深度整合进日常采编流程。新华社的"媒体大脑"系统、央视的"AI创作平台"等产品，能够实现新闻快讯的秒级生成、数据报告的自动撰写。在保持人工审核的前提下，AI辅助写作将常规新闻的生产效率提升了5-8倍。</p>
    <h2>二、虚拟人技术：24小时不间断的内容生产</h2>
    <p>虚拟主播、虚拟记者已经成为传媒行业的"新员工"。央视推出的AI虚拟主播"小C"已经累计播报超过10000条新闻，准确率达到99.7%。虚拟人技术让传媒机构实现了7x24小时的内容生产能力，大幅降低了人力成本。</p>
    <h2>三、个性化分发：千人千面的内容体验</h2>
    <p>基于深度学习的推荐算法正在让每个用户获得专属的内容消费体验。头部平台的内容点击率在引入AI推荐后平均提升了35%，用户留存率提升了28%。但同时也引发了关于"信息茧房"的深度讨论。</p>`,
    category: 'tech-digital',
    categoryName: '科技数码',
    author: '李思涵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20modern%20office%20attire%20with%20warm%20lighting%20and%20clean%20white%20background%2C%20editorial%20headshot%20photography&width=80&height=80&seq=avatar-li-2025&orientation=squarish',
    publishDate: '2025-12-25',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20media%20control%20room%20with%20holographic%20displays%20and%20warm%20ambient%20lighting%2C%20AI%20technology%20visualization%20with%20data%20streams%2C%20modern%20broadcast%20studio%20atmosphere%2C%20cinematic%20lighting%20with%20golden%20tones&width=1600&height=900&seq=ai-media-2025&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    tags: ['人工智能', '传媒技术', '内容生产', '虚拟主播'],
    isHot: true,
    isFeatured: false,
  },
  {
    slug: 'variety-show-2025-trends',
    title: '2025综艺市场新风向：文化类节目崛起，慢综艺持续走红',
    excerpt: '2025年的综艺市场呈现出明显的"文化回归"趋势。以传统文化为核心的综艺节目异军突起，慢综艺、观察类综艺持续受到观众追捧。',
    content: `<p>2025年的综艺市场正在经历一场静悄悄的变革。曾经占据荧屏主导地位的竞技类、选秀类综艺逐渐降温，取而代之的是文化类、慢综艺和观察类节目的全面崛起。</p>
    <h2>一、文化类综艺全面爆发</h2>
    <p>《典籍里的中国》第三季以超过5%的平均收视率领跑综艺市场，《诗词大会2025》网络播放量突破50亿次。以传统文化为核心的综艺节目不仅在收视数据上表现出色，更在社交媒体上持续引发热议，"文化自信"正在成为综艺创作的核心关键词。</p>
    <h2>二、慢综艺持续走红</h2>
    <p>《向往的生活》《中餐厅》等慢综艺依然保持强劲的市场号召力。2025年慢综艺的市场份额达到28%，较上年增长5个百分点。观众对"治愈系"内容的需求持续增长，慢综艺以其真实、温暖的特质满足了这一需求。</p>`,
    category: 'entertainment',
    categoryName: '娱乐综艺',
    author: '王雨桐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20young%20female%20portrait%20with%20creative%20style%20and%20warm%20lighting%2C%20clean%20background%2C%20editorial%20headshot&width=80&height=80&seq=avatar-wang-2025&orientation=squarish',
    publishDate: '2025-12-22',
    readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20studio%20set%20with%20traditional%20cultural%20elements%20and%20warm%20stage%20lighting%2C%20elegant%20Chinese%20aesthetic%20design%20with%20modern%20broadcast%20equipment%2C%20cinematic%20atmosphere&width=1600&height=900&seq=variety-2025&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    tags: ['综艺节目', '文化类综艺', '慢综艺', '市场趋势'],
    isHot: true,
    isFeatured: false,
  },
  {
    slug: 'short-video-ecology-2025',
    title: '短视频生态进化论：从流量争夺到价值深耕',
    excerpt: '2025年，短视频行业告别野蛮生长，进入精细化运营时代。创作者经济、本地生活服务、知识付费成为短视频平台的三大增长引擎。',
    content: `<p>经过近十年的高速发展，中国短视频行业在2025年正式进入"下半场"。日活跃用户规模稳定在10亿量级，增长红利见顶，行业竞争从"流量争夺"全面转向"价值深耕"。</p>
    <h2>一、创作者经济走向成熟</h2>
    <p>2025年，短视频创作者的总收入规模突破5000亿元。平台分成、品牌合作、直播带货、知识付费、IP授权等多元变现模式走向成熟。头部创作者年收入过亿已成常态，腰部创作者的收入中位数达到50万元。</p>
    <h2>二、本地生活服务成新战场</h2>
    <p>抖音、快手等平台将本地生活服务作为核心战略方向。2025年短视频平台本地生活GMV突破8000亿元，同比增长60%。餐饮、旅游、美业成为三大核心品类。</p>`,
    category: 'tech-digital',
    categoryName: '科技数码',
    author: '陈浩然',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20with%20tech%20style%20and%20warm%20lighting%2C%20clean%20white%20background%2C%20editorial%20headshot&width=80&height=80&seq=avatar-chen-2025&orientation=squarish',
    publishDate: '2025-12-20',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20content%20creator%20studio%20with%20warm%20lighting%20and%20professional%20video%20equipment%2C%20smartphone%20on%20tripod%20with%20ring%20light%2C%20creative%20workspace%20atmosphere%2C%20editorial%20photography&width=1600&height=900&seq=short-video-2025&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    tags: ['短视频', '创作者经济', '本地生活', '行业趋势'],
    isHot: false,
    isFeatured: false,
  },
  {
    slug: 'intangible-cultural-heritage-digital',
    title: '当非遗遇见数字化：传统文化传承的创新路径',
    excerpt: '数字化技术正在为非物质文化遗产的保护与传承开辟全新道路。从3D扫描到虚拟现实，从数字藏品到沉浸式展览，科技让古老文化焕发新生。',
    content: `<p>在数字化浪潮的推动下，中国非物质文化遗产的保护与传承正在经历一场深刻变革。数字化技术不仅改变了非遗的记录和保存方式，更重塑了非遗的传播和消费模式。</p>
    <h2>一、数字化记录：让非遗永续传承</h2>
    <p>2025年，全国已有超过80%的国家级非遗项目完成了数字化采集。3D激光扫描、8K超高清拍摄、动作捕捉等技术的应用，让传统技艺的每一个细节得以精确记录。故宫博物院推出的"数字文物库"已收录超过100万件文物的高清数字影像。</p>
    <h2>二、沉浸式体验：让非遗触手可及</h2>
    <p>VR/AR技术正在让公众以前所未有的方式体验非遗文化。敦煌研究院推出的"数字敦煌"VR体验项目，2025年累计接待线上游客超过2000万人次。"云游非遗"系列产品让偏远地区的非遗项目获得了全国乃至全球的关注。</p>`,
    category: 'culture-art',
    categoryName: '文化艺术',
    author: '林晓薇',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20with%20artistic%20style%20and%20warm%20natural%20lighting%2C%20clean%20background%2C%20editorial%20headshot&width=80&height=80&seq=avatar-lin-2025&orientation=squarish',
    publishDate: '2025-12-18',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20cultural%20heritage%20artifacts%20displayed%20with%20modern%20holographic%20digital%20technology%2C%20museum%20exhibition%20with%20warm%20golden%20lighting%2C%20fusion%20of%20ancient%20and%20futuristic%20elements&width=1600&height=900&seq=ich-digital-2025&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    tags: ['非物质文化遗产', '数字化', '文化传承', 'VR技术'],
    isHot: false,
    isFeatured: false,
  },
  {
    slug: 'content-creator-economy-2025',
    title: '内容创作者经济白皮书：2025年中国创作者生态全景扫描',
    excerpt: '2025年中国内容创作者数量突破1.2亿，创作者经济总产值达到1.8万亿元。本文全面解析创作者生态的现状、挑战与未来趋势。',
    content: `<p>2025年，中国内容创作者经济进入全新发展阶段。据《中国内容创作者经济发展报告》显示，全平台内容创作者数量突破1.2亿人，创作者经济总产值达到1.8万亿元，占GDP比重约1.4%。</p>
    <h2>一、创作者规模与结构</h2>
    <p>在1.2亿创作者中，全职创作者约800万人，兼职创作者约1.12亿人。从平台分布来看，短视频平台创作者占比最高（45%），其次是图文平台（28%）、直播平台（18%）和音频平台（9%）。</p>
    <h2>二、收入结构与分化</h2>
    <p>创作者收入呈现明显的"金字塔"结构。头部0.1%的创作者贡献了约30%的总收入，腰部10%的创作者贡献了约45%的收入，而底层约90%的创作者月收入不足3000元。收入来源中，品牌合作（35%）、直播带货（28%）、平台分成（20%）位列前三。</p>`,
    category: 'business-finance',
    categoryName: '商业财经',
    author: '赵思远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20with%20business%20attire%20and%20warm%20lighting%2C%20clean%20white%20background%2C%20editorial%20headshot%20photography&width=80&height=80&seq=avatar-zhao-2025&orientation=squarish',
    publishDate: '2025-12-15',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20creative%20workspace%20with%20multiple%20screens%20and%20content%20creation%20setup%2C%20warm%20ambient%20lighting%20with%20wooden%20desk%2C%20professional%20studio%20atmosphere%2C%20editorial%20photography&width=1600&height=900&seq=creator-economy&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    tags: ['创作者经济', '内容产业', '行业报告', '商业分析'],
    isHot: false,
    isFeatured: false,
  },
  {
    slug: 'news-media-transformation-2025',
    title: '传统媒体数字化转型：从纸媒到智媒的跨越式发展',
    excerpt: '2025年，中国传统媒体的数字化转型进入深水区。从中央级媒体到地方报社，智能化、平台化、视频化成为转型的三大核心方向。',
    content: `<p>2025年是中国传统媒体数字化转型的关键之年。在政策引导、技术驱动和市场倒逼的三重作用下，传统媒体的数字化进程全面加速。</p>
    <h2>一、中央媒体引领智能化转型</h2>
    <p>人民日报、新华社、中央广播电视总台等中央级媒体继续引领行业智能化转型。人民日报"人民号"平台入驻创作者超过50万，新华社"现场云"直播平台2025年累计直播超过100万场。AI技术在新闻采编全流程的应用覆盖率达到75%。</p>
    <h2>二、地方媒体探索差异化路径</h2>
    <p>地方媒体在数字化转型中走出了各具特色的道路。浙江日报报业集团的"潮新闻"客户端下载量突破5000万，四川日报报业集团的"封面新闻"在短视频领域表现亮眼。县域融媒体中心的建设也在2025年实现了全覆盖。</p>`,
    category: 'news-info',
    categoryName: '新闻资讯',
    author: '刘建国',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20senior%20male%20portrait%20in%20formal%20attire%20with%20warm%20lighting%2C%20clean%20white%20background%2C%20editorial%20headshot&width=80&height=80&seq=avatar-liu-2025&orientation=squarish',
    publishDate: '2025-12-12',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20large%20digital%20screens%20displaying%20data%20visualizations%2C%20journalists%20working%20at%20computers%2C%20warm%20professional%20atmosphere%20with%20ambient%20lighting&width=1600&height=900&seq=news-transformation&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    tags: ['传统媒体', '数字化转型', '智能化', '融媒体'],
    isHot: false,
    isFeatured: true,
  },
  {
    slug: 'esports-industry-report-2025',
    title: '2025中国电竞产业报告：千亿市场规模下的新机遇',
    excerpt: '2025年中国电竞产业总产值突破1800亿元，用户规模达到5.2亿。电竞赛事、游戏直播、电竞教育、电竞文旅等细分领域呈现多元化发展态势。',
    content: `<p>2025年，中国电竞产业继续保持高速增长态势。据《2025中国电子竞技产业报告》显示，全年电竞产业总产值达到1850亿元，同比增长22%。</p>
    <h2>一、电竞赛事商业价值持续攀升</h2>
    <p>2025年王者荣耀世界冠军杯、英雄联盟全球总决赛中国区等顶级赛事的总奖金池突破10亿元。赛事赞助收入突破300亿元，品牌合作从传统的外设、饮料扩展到汽车、金融、奢侈品等领域。</p>
    <h2>二、电竞入亚推动主流化进程</h2>
    <p>继2023年杭州亚运会将电竞列为正式比赛项目后，2026年爱知·名古屋亚运会的电竞项目设置进一步扩大。电竞的主流化进程正在加速，社会认可度持续提升。</p>`,
    category: 'entertainment',
    categoryName: '娱乐综艺',
    author: '周晓峰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20young%20male%20portrait%20with%20casual%20style%20and%20warm%20lighting%2C%20clean%20white%20background%2C%20editorial%20headshot&width=80&height=80&seq=avatar-zhou-2025&orientation=squarish',
    publishDate: '2025-12-10',
    readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20dramatic%20stage%20lighting%20and%20large%20LED%20screens%2C%20packed%20audience%20watching%20gaming%20competition%2C%20cinematic%20atmosphere%20with%20warm%20golden%20accents&width=1600&height=900&seq=esports-2025&orientation=landscape',
    imageWidth: 1600,
    imageHeight: 900,
    tags: ['电竞产业', '游戏直播', '电竞赛事', '产业报告'],
    isHot: false,
    isFeatured: false,
  },
];